module.exports = __webpack_public_path__ + "img/off.81be2145.png";